import { render } from "./OnDemandEducation.vue?vue&type=template&id=76a9e7e4"
import script from "./OnDemandEducation.vue?vue&type=script&lang=js"
export * from "./OnDemandEducation.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__